const getters = {
    openId: state => state.app.openId,
    studentId: state => state.app.studentId,
}

export default getters
